import _ from "lodash";
import { detect } from "detect-browser";
import screenfull from "screenfull";
import {
  IGPSLocation,
  LightColors,
  IGeofence,
  IGeometry,
  ITrackData,
} from "@thingsw/pitta-modules";

// mantis - 8437, MPH로 설정 시 0 MPH로 표시
const getSpeedValue = (loc: IGPSLocation, speedUnit?: string) => {
  const speed = parseFloat(loc.speed ?? "0");
  if (loc.active === "off") {
    return `0 km/h`;
  } else if (speed <= 0) {
    return `0 ${speedUnit === "1" ? "MPH" : "km/h"}`;
  } else if (speedUnit === "1") {
    return `${Math.floor(speed * 1.150779)} MPH`;
  } else {
    return `${Math.floor(speed * 1.852)} km/h`;
  }
};

export const getLocationLabel = (
  loc: IGPSLocation,
  speedUnit?: string,
  hideName?: boolean
) => {
  // 파킹모드면서 내 대시캠 볼떄는 이름 표시 안함 + 속도도 표시 안함
  // if (hideName && loc.mode === "1") {
  //   return;
  // }

  const isParking = loc.active === "on" && loc.mode === "1";
  const showSpeed =
    loc.speed !== undefined && loc.mode === "0" && loc.active === "on";
  // mantis : 8438
  // cloud가 해제된 카메라는 이름크기만큼만 높이가 나오도록 수정.
  let height = 19;
  if (!hideName && loc.mode === "0" && loc.active === "on") {
    height = 29;
  }
  const padding = 2;
  const paddingHeight = 0;
  let name = hideName ? "" : loc.name ?? "";
  const maxTextWidth = isParking ? 74 : 84;
  const textPadding = isParking ? 26 : 16;
  let textWidth = getTextWidth(name, "11px Roboto") + textPadding;
  if (textWidth > maxTextWidth + textPadding) {
    do {
      name = name.substring(0, name.length - 2);

      textWidth = getTextWidth(name, "11px Roboto");
    } while (textWidth > maxTextWidth);
    name = name + "...";
    textWidth = getTextWidth(name, "11px Roboto") + textPadding;
  }
  const speedValue = getSpeedValue(loc, speedUnit);
  const speedWidth = getTextWidth(speedValue, "9px Roboto") + textPadding;
  if (!loc.name || hideName) {
    textWidth = 16;
  }
  if (textWidth < speedWidth && showSpeed) {
    textWidth = Math.min(speedWidth, 100);
  }
  // mantis : 8438
  //  cloud가 해제된 카메라는 speedText가 나타나지 않게 수정.
  const speedText =
    showSpeed &&
    `<text x="${(textWidth + padding) / 2}" y="${
      hideName ? 14 : 25
    }" font-family="Roboto" font-size="9" text-anchor="middle" fill="${LightColors.primary[
      "2"
    ].replace("#", "%23")}" >${speedValue}</text>`;

  // 이름도 표시 안하고 속도도 표시 안하는 경우(parking모드)
  if (!loc.name && !speedText) {
    textWidth = 16;
  }

  let parkingMarkup = "";
  let nameTextTranslate = "";
  if (loc.active === "on" && loc.mode === "1") {
    parkingMarkup = `<g transform="translate(${textWidth + padding - 12}, 6)">
      <path d="M0.5 0.5H4.26923C5.12608 0.5 5.94784 0.816071 6.55373 1.37868C7.15962 1.94129 7.5 2.70435 7.5 3.5C7.5 4.29565 7.15962 5.05871 6.55373 5.62132C5.94784 6.18393 5.12608 6.5 4.26923 6.5H2.65385V9.5H0.5V0.5ZM2.65385 2.5V4.5H4.26923C4.55485 4.5 4.82877 4.39464 5.03073 4.20711C5.23269 4.01957 5.34615 3.76522 5.34615 3.5C5.34615 3.23478 5.23269 2.98043 5.03073 2.79289C4.82877 2.60536 4.55485 2.5 4.26923 2.5H2.65385Z" fill="%232EA8E5"/>
      </g>`;
    nameTextTranslate = `transform="translate(-4,0)"`;
  }

  console.log(
    "LocationMap",
    "getLocationLabel",
    loc,
    "hideName",
    hideName,
    "height",
    height,
    "name",
    name,
    "isParking",
    isParking,
    "maxTextWidth",
    maxTextWidth,
    "textPadding",
    textPadding,
    "speedWidth",
    speedWidth,
    "speedText",
    speedText,
    "single",
    !(!hideName && loc.mode === "0" && loc.active === "on")
  );
  return {
    width: textWidth + padding,
    height: height + paddingHeight,
    single: !(!hideName && loc.mode === "0" && loc.active === "on"),
    svg: `data:image/svg+xml;utf-8,
    <svg width="${textWidth + padding}" height="${
      height + paddingHeight
    }" viewBox="0 0 ${textWidth + padding} ${
      height + paddingHeight
    }" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
      <g >
          <rect x="0" y="0" width="${textWidth + padding}" height="${
      height + paddingHeight
    }" rx="4" ry="4" fill="white" />
      </g>

      <g ${nameTextTranslate}>
      <text x="${
        (textWidth + padding) / 2
      }" y="${14}" font-family="Roboto" font-size="11" text-anchor="middle" fill="${LightColors.primary[
      "1"
    ].replace("#", "%23")}" >${name}</text>
      </g>
      ${parkingMarkup}

      ${speedText}
      </g>
      
    </svg>`,
  };
};

export function getElementByXpath(path: string) {
  return document.evaluate(
    path,
    document,
    null,
    XPathResult.FIRST_ORDERED_NODE_TYPE,
    null
  ).singleNodeValue;
}

export const simulateDblClick = (x: number, y: number) => {
  const event = new MouseEvent("dblclick", {
    view: window,
    bubbles: true,
    cancelable: true,
    screenX: x,
    screenY: y,
  });

  const element = document.elementFromPoint(x, y);

  element?.dispatchEvent(event);
};

export function toggleFullscreen(element: HTMLElement) {
  const browser = detect();
  //@ts-ignore
  console.log("element", element, element.fullscreen);
  //@ts-ignore
  if (element.fullscreen) {
    console.log("element is fullscreen");
    //@ts-ignore
    element.fullscreen = false;
    if (browser?.name === "ios-webview") {
      //@ts-ignore
      exitFullscreen(element);
    } else {
      //@ts-ignore
      screenfull.toggle(element);
    }
  } else {
    console.log("element is not fullscreen", browser?.name, element);
    //@ts-ignore
    element.fullscreen = true;

    if (browser?.name === "ios-webview") {
      //@ts-ignore
      requestFullscreen(element);
    } else {
      //@ts-ignore
      screenfull.request(element);
    }
  }
}

//|| (browser?.os === "Android OS" && browser?.name === "chrome")
// @ts-nocheck
export function isFullscreen(element: HTMLElement) {
  const browser = detect();
  console.log("isFullscreen", browser);
  if (browser?.name === "ios" || browser?.name === "crios") {
    return element.classList.contains("ios-map-fullscreen");
  } else {
    //@ts-ignore
    return screenfull.isFullscreen;
  }
}

export function requestFullscreen(element: HTMLElement) {
  const browser = detect();
  console.log("requestFullscreen", browser);
  if (
    browser?.name === "ios" ||
    browser?.name === "crios" ||
    browser?.name === "ios-webview"
  ) {
    element.classList.add("ios-map-fullscreen");
  } else {
    //@ts-ignore
    screenfull.request(element);
  }
}

export function exitFullscreen(element: HTMLElement) {
  const browser = detect();
  if (
    browser?.name === "ios" ||
    browser?.name === "crios" ||
    browser?.name === "ios-webview"
  ) {
    element.classList.remove("ios-map-fullscreen");
  } else {
    // @ts-ignore
    screenfull.exit();
  }
}

export const DMStoDegree = (dms: number) => {
  const degree = Math.floor(dms / 100);
  const min = (dms / 100 - degree) * 100;
  // console.log("DMStoDegree", dms, degree, min, degree + min / 60);
  return degree + min / 60;
};

export const getAngle = (v1: number[], v2: number[]) => {
  const dx = v2[0] - v1[0];
  const dy = v2[1] - v1[1];
  if (dx > 0) {
    return Math.PI * 0.5 - Math.atan2(dy, dx);
  } else if (dx < 0) {
    return Math.PI * 1.5 - Math.atan2(dy, dx);
  } else if (dy > 0) {
    return 0;
  } else if (dy < 0) {
    return Math.PI;
  }
  return NaN;
};

export const getTextWidth = (text: string, font: string) => {
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");

  if (context) {
    context.font = font || getComputedStyle(document.body).font;
  }

  return context?.measureText(text).width ?? 0;
};

export const convertGeofenceToGeometries = (geofences: IGeofence[]) => {
  return _.chain(geofences)
    .map((geofence) => {
      if (geofence.polygon) {
        return {
          fenceId: geofence.fenceId,
          type: "polygon",
          coords: geofence.polygon,
          color: geofence.setShape.Color,
          opacity: geofence.setShape.Transparency,
        } as IGeometry;
      } else if (geofence.polyline) {
        return {
          fenceId: geofence.fenceId,
          type: "polyline",
          coords: geofence.polyline,
          color: geofence.setShape.Color,
          opacity: geofence.setShape.Transparency,
        } as IGeometry;
      } else if (geofence.circle) {
        return {
          fenceId: geofence.fenceId,
          type: "circle",
          center: {
            lat: geofence.circle[0].lat,
            lng: geofence.circle[0].lng,
          },
          radius: geofence.circle[0].radius,
          color: geofence.setShape.Color,
          opacity: geofence.setShape.Transparency,
        } as IGeometry;
      } else if (geofence.rectangle) {
        const east = _.chain(geofence.rectangle)
          .map((r) => r.lng)
          .max()
          .value();
        const west = _.chain(geofence.rectangle)
          .map((r) => r.lng)
          .min()
          .value();
        const north = _.chain(geofence.rectangle)
          .map((r) => r.lat)
          .max()
          .value();
        const south = _.chain(geofence.rectangle)
          .map((r) => r.lat)
          .min()
          .value();
        return {
          fenceId: geofence.fenceId,
          type: "rectangle",
          bounds: { east, west, north, south },
          color: geofence.setShape.Color,
          opacity: geofence.setShape.Transparency,
        } as IGeometry;
      }
      return undefined;
    })
    .compact()
    .value();
};

export const renderGeofences = (
  map: any,
  maps: any,
  geometries: IGeometry[],
  mobile: boolean,
  fitBounds: boolean,
  onSelectGeofence?: (fenceId: string) => void
) => {
  let minLat = 999,
    minLng = 999,
    maxLat = -999,
    maxLng = -999;
  const objects = _.chain(geometries)
    .map((geo) => {
      if (geo.type === "polygon") {
        _.forEach(geo.coords, (coord) => {
          minLat = Math.min(minLat, coord.lat);
          minLng = Math.min(minLng, coord.lng);
          maxLat = Math.max(maxLat, coord.lat);
          maxLng = Math.max(maxLng, coord.lng);
        });
        const obj = new maps.Polygon({
          paths: geo.coords,
          strokeColor: geo.color,
          strokeWeight: 3,
          fillColor: geo.color,
          fillOpacity: geo.opacity,
        });
        obj.setMap(map);
        obj.addListener("click", () => {
          onSelectGeofence && geo.fenceId && onSelectGeofence(geo.fenceId);
        });
        return obj;
      } else if (geo.type === "polyline") {
        _.forEach(geo.coords, (coord) => {
          minLat = Math.min(minLat, coord.lat);
          minLng = Math.min(minLng, coord.lng);
          maxLat = Math.max(maxLat, coord.lat);
          maxLng = Math.max(maxLng, coord.lng);
        });
        const obj = new maps.Polyline({
          path: geo.coords,
          geodesic: true,
          strokeColor: geo.color,
          strokeWeight: 3,
          strokeOpacity: 1.0,
        });
        obj.setMap(map);
        obj.addListener("click", () => {
          onSelectGeofence && geo.fenceId && onSelectGeofence(geo.fenceId);
        });
        return obj;
      } else if (geo.type === "circle") {
        const obj = new maps.Circle({
          center: geo.center,
          radius: geo.radius,
          strokeColor: geo.color,
          strokeWeight: 3,
          fillColor: geo.color,
          fillOpacity: geo.opacity,
        });
        obj.setMap(map);
        const bound = obj.getBounds();
        const ne = bound.getNorthEast();
        const sw = bound.getSouthWest();
        minLat = Math.min(minLat, sw.lat());
        minLng = Math.min(minLng, sw.lng());
        maxLat = Math.max(maxLat, ne.lat());
        maxLng = Math.max(maxLng, ne.lng());
        obj.addListener("click", () => {
          onSelectGeofence && geo.fenceId && onSelectGeofence(geo.fenceId);
        });
        return obj;
      } else if (geo.type === "rectangle") {
        const obj = new maps.Rectangle({
          bounds: geo.bounds,
          strokeColor: geo.color,
          strokeWeight: 3,
          fillColor: geo.color,
          fillOpacity: geo.opacity,
        });
        obj.setMap(map);
        const bound = geo.bounds;
        if (bound) {
          minLat = Math.min(minLat, bound.south);
          minLng = Math.min(minLng, bound.west);
          maxLat = Math.max(maxLat, bound.north);
          maxLng = Math.max(maxLng, bound.east);
        }

        obj.addListener("click", () => {
          onSelectGeofence && geo.fenceId && onSelectGeofence(geo.fenceId);
        });
        return obj;
      }
      return undefined;
    })
    .compact()
    .value();

  if (fitBounds) {
    map.fitBounds({
      east: maxLng,
      north: maxLat,
      west: minLng,
      south: minLat,
    });
  }

  return objects;
};

export const getIcon = (
  d: ITrackData,
  type: "first" | "last" | "arrow" | "event",
  maps: any,
  tindx?: number, // tindx or heading
  big?: boolean
) => {
  const width = big ? 46 : 38;
  const height = big ? 50 : 42;
  if (type === "first") {
    return {
      anchor: new maps.Point(16, 40),
      size: new maps.Size(32, 47),
      scaledSize: new maps.Size(32, 47),
      url: `data:image/svg+xml;utf-8,
    <svg width="32" height="47" viewBox="0 0 32 47" fill="none" xmlns="http://www.w3.org/2000/svg" id="event-marker">
    <ellipse cx="16" cy="40.5" rx="6" ry="3.5" fill="%23D81A26"/>
    <g filter="url(%23filter0_d)">
    <mask id="path-2-inside-1" fill="white">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M18 25.8186C23.1202 24.8781 27 20.3921 27 15C27 8.92487 22.0751 4 16 4C9.92487 4 5 8.92487 5 15C5 20.3921 8.87976 24.8781 14 25.8186V41H18V25.8186Z"/>
    </mask>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M18 25.8186C23.1202 24.8781 27 20.3921 27 15C27 8.92487 22.0751 4 16 4C9.92487 4 5 8.92487 5 15C5 20.3921 8.87976 24.8781 14 25.8186V41H18V25.8186Z" fill="%23D81A26"/>
    <path d="M18 25.8186L17.8193 24.8351L17 24.9856V25.8186H18ZM14 25.8186H15V24.9856L14.1807 24.8351L14 25.8186ZM14 41H13V42H14V41ZM18 41V42H19V41H18ZM26 15C26 19.9009 22.4735 23.9802 17.8193 24.8351L18.1807 26.8022C23.767 25.776 28 20.8834 28 15H26ZM16 5C21.5228 5 26 9.47715 26 15H28C28 8.37258 22.6274 3 16 3V5ZM6 15C6 9.47715 10.4772 5 16 5V3C9.37258 3 4 8.37258 4 15H6ZM14.1807 24.8351C9.52652 23.9802 6 19.9009 6 15H4C4 20.8834 8.23301 25.776 13.8193 26.8022L14.1807 24.8351ZM15 41V25.8186H13V41H15ZM18 40H14V42H18V40ZM17 25.8186V41H19V25.8186H17Z" fill="white" mask="url(%23path-2-inside-1)"/>
    </g>
    <text text-anchor="middle" alignment-baseline="middle"  fill="%23ffffff" x="16" y="16" font-size="10" font-family="rotobo">A${tindx}</text>
    <defs>
    <filter id="filter0_d" x="0" y="0" width="32" height="47" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
    <feOffset dy="1"/>
    <feGaussianBlur stdDeviation="2.5"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0.847059 0 0 0 0 0.101961 0 0 0 0 0.14902 0 0 0 0.45 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
    </filter>
    </defs>
    </svg>
    `,
    };
  } else if (type === "last") {
    return {
      anchor: new maps.Point(7, 40),
      size: new maps.Size(35, 47),
      scaledSize: new maps.Size(35, 47),
      url: `data:image/svg+xml;utf-8,
    <svg width="35" height="47" viewBox="0 0 35 47" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="7" cy="40.5" rx="6" ry="3.5" fill="%23D81A26"/>
    <g filter="url(%23filter0_d)">
    <path d="M30 7H9V4H5V41H9V25H30L25 16L30 7Z" fill="%23D81A26"/>
    <path d="M8.5 7V7.5H9H29.1502L24.5629 15.7572L24.428 16L24.5629 16.2428L29.1502 24.5H9H8.5V25V40.5H5.5V4.5H8.5V7Z" stroke="white"/>
    </g>
    <defs>
    <filter id="filter0_d" x="0" y="0" width="35" height="47" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
    <feOffset dy="1"/>
    <feGaussianBlur stdDeviation="2.5"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0.847059 0 0 0 0 0.101961 0 0 0 0 0.14902 0 0 0 0.45 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
    </filter>
    </defs>
    </svg>`,
    };
  } else if (type === "arrow") {
    return {
      anchor: new maps.Point(10, 10),
      size: new maps.Size(20, 20),
      scaledSize: new maps.Size(20, 20),
      url: `data:image/svg+xml;utf-8,
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g transform="rotate(${tindx},10,10)">
      <path d="M4 16.2632L10 3L16 16.2632L15.2 17L10 15L4.8 17L4 16.2632Z" fill="%230095E0"/>
      <path d="M10.1795 14.5333L10 14.4643L9.82051 14.5333L4.91033 16.4219L4.60444 16.1401L10 4.2131L15.3956 16.1401L15.0897 16.4219L10.1795 14.5333Z" stroke="white"/>
      </g>
    </svg>`,
    };
  } else if (type === "event") {
    if (d.mode === "M") {
      return {
        anchor: new maps.Point(width / 2, height - 6),
        size: new maps.Size(width, height),
        scaledSize: new maps.Size(width, height),
        url: `data:image/svg+xml;utf-8,
        <svg width="${width}" height="${height}" viewBox="0 0 38 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(%23filter0_d_14309_4164)">
        <path d="M32.5 17.7143C32.5 23.4606 28.7508 28.3588 23.5031 30.1757C22.8482 30.4025 22.3353 30.9237 21.9187 31.4855C21.513 32.0326 21.1524 32.6838 20.8209 33.2824C20.8089 33.3042 20.7969 33.3259 20.7849 33.3475C20.4332 33.9822 20.1176 34.5436 19.7904 34.9497C19.4543 35.3668 19.2007 35.5 19 35.5C18.7997 35.5 18.5487 35.3681 18.2162 34.9528C17.8919 34.5479 17.5801 33.9882 17.2306 33.3537L17.2044 33.3061C16.8723 32.7031 16.5096 32.0444 16.0975 31.4906C15.6777 30.9265 15.1601 30.4053 14.4969 30.1757C9.24924 28.3588 5.5 23.4606 5.5 17.7143C5.5 10.4259 11.5344 4.5 19 4.5C26.4656 4.5 32.5 10.4259 32.5 17.7143Z" fill="%23ED9600" stroke="white"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.14 19.6188C13.1443 19.4995 13.1203 19.3809 13.0699 19.2727C13.0194 19.1646 12.9441 19.07 12.85 18.9969C12.5437 18.7899 12.206 18.6341 11.85 18.5354C11.4534 18.404 11.0659 18.2465 10.69 18.0639C10.2721 17.9168 9.9083 17.6466 9.64603 17.2886C9.38376 16.9307 9.23526 16.5017 9.22 16.0577C9.21341 15.6567 9.34006 15.265 9.57999 14.9442C9.84189 14.6099 10.1867 14.3505 10.58 14.1918C11.0782 14.005 11.6085 13.9198 12.14 13.9411C12.6416 13.9346 13.1389 14.0337 13.6 14.232C14.0028 14.4128 14.3486 14.7008 14.6 15.0646C14.8411 15.4301 14.9666 15.8602 14.96 16.2984H13.14C13.1489 16.1663 13.1284 16.0339 13.08 15.9107C13.0316 15.7875 12.9564 15.6767 12.86 15.5862C12.646 15.4038 12.3704 15.3105 12.09 15.3254C11.8158 15.3091 11.5442 15.387 11.32 15.5461C11.229 15.6028 11.154 15.6819 11.102 15.7758C11.05 15.8697 11.0227 15.9753 11.0227 16.0828C11.0227 16.1902 11.05 16.2958 11.102 16.3897C11.154 16.4836 11.229 16.5627 11.32 16.6194C11.6589 16.8397 12.0301 17.0055 12.42 17.111C12.8867 17.2465 13.3389 17.428 13.77 17.6527C14.1419 17.8369 14.4539 18.1232 14.6699 18.4784C14.8859 18.8336 14.9969 19.2429 14.99 19.6589C15.0016 19.9613 14.9394 20.262 14.8087 20.5348C14.678 20.8075 14.4827 21.0441 14.24 21.2238C13.6386 21.6369 12.9176 21.8381 12.19 21.7956C11.6094 21.8096 11.0327 21.6967 10.5 21.4646C10.0286 21.256 9.63362 20.9054 9.36997 20.4614C9.11762 20.067 8.98876 19.6058 8.99997 19.1373H10.83C10.8151 19.3012 10.835 19.4664 10.8884 19.6221C10.9418 19.7777 11.0276 19.9202 11.14 20.0401C11.428 20.2538 11.7827 20.3569 12.14 20.331C12.3952 20.3427 12.6474 20.2724 12.86 20.1304C12.9431 20.0728 13.0116 19.9966 13.0602 19.9078C13.1088 19.819 13.1361 19.72 13.14 19.6188ZM22.31 18.0036C22.3276 18.695 22.1874 19.3813 21.9 20.0099C21.646 20.5298 21.2552 20.9703 20.77 21.2839C20.2515 21.5973 19.6552 21.7573 19.05 21.7453C18.4461 21.7571 17.8507 21.6008 17.33 21.2939C16.8239 20.9935 16.4171 20.5504 16.16 20.0199C15.8773 19.4281 15.7304 18.7803 15.73 18.124V17.6927C15.7092 17.0021 15.846 16.3158 16.13 15.6864C16.381 15.1724 16.773 14.7409 17.26 14.4425C17.7838 14.1368 18.379 13.9757 18.985 13.9757C19.591 13.9757 20.1862 14.1368 20.71 14.4425C21.2152 14.7573 21.6209 15.2095 21.88 15.7466C22.1674 16.3546 22.3143 17.0198 22.31 17.6927V18.0036ZM20.45 17.6826C20.4903 17.0861 20.3584 16.4905 20.07 15.9673C19.96 15.7822 19.803 15.6299 19.6149 15.5259C19.4269 15.4219 19.2146 15.3699 19 15.3754C18.08 15.3754 17.6 16.0676 17.55 17.4419V18.0036C17.5142 18.5986 17.6422 19.1921 17.92 19.719C18.0316 19.9094 18.1932 20.0653 18.3872 20.1697C18.5812 20.2741 18.8001 20.3229 19.02 20.3108C19.2325 20.3187 19.4432 20.2688 19.6298 20.1664C19.8164 20.0639 19.972 19.9128 20.08 19.729C20.3616 19.2105 20.4932 18.6233 20.46 18.0337L20.45 17.6826ZM27.0843 19.2742C27.133 19.3823 27.1555 19.5003 27.15 19.6188C27.1462 19.72 27.1188 19.819 27.0702 19.9078C27.0216 19.9966 26.953 20.0728 26.87 20.1304C26.6574 20.2725 26.4052 20.3427 26.15 20.331C25.7927 20.357 25.438 20.2538 25.15 20.0401C25.0376 19.9202 24.9518 19.7777 24.8984 19.6221C24.845 19.4665 24.8251 19.3012 24.84 19.1373H23.01C22.9988 19.6058 23.1276 20.067 23.38 20.4614C23.6462 20.9033 24.0404 21.2533 24.51 21.4646C25.0396 21.6953 25.6127 21.8082 26.19 21.7956C26.9205 21.8365 27.6443 21.6356 28.25 21.2238C28.4915 21.0436 28.6853 20.8067 28.8144 20.5339C28.9434 20.261 29.0036 19.9606 28.99 19.6589C28.9969 19.243 28.8859 18.8336 28.6699 18.4784C28.4539 18.1232 28.1419 17.8369 27.77 17.6527C27.3485 17.4298 26.9064 17.2484 26.45 17.111C26.0607 17.0038 25.6898 16.838 25.35 16.6194C25.2594 16.5649 25.1837 16.4887 25.1296 16.3977C25.0755 16.3067 25.0448 16.2037 25.04 16.0978C25.0392 15.9901 25.0642 15.8837 25.1129 15.7877C25.1616 15.6917 25.2326 15.6088 25.32 15.5461C25.5442 15.387 25.8158 15.3092 26.09 15.3254C26.3704 15.3105 26.646 15.4039 26.86 15.5862C26.9564 15.6767 27.0316 15.7875 27.08 15.9107C27.1284 16.0339 27.1489 16.1663 27.14 16.2984H28.96C28.9653 15.8618 28.8437 15.433 28.61 15.0646C28.3575 14.7018 28.012 14.4142 27.61 14.232C27.149 14.0338 26.6516 13.9347 26.15 13.9411C25.6219 13.9211 25.0951 14.0064 24.6 14.1919C24.2067 14.3505 23.8619 14.6099 23.6 14.9442C23.3601 15.265 23.2334 15.6567 23.24 16.0577C23.2552 16.5017 23.4037 16.9307 23.666 17.2886C23.9283 17.6466 24.2921 17.9168 24.71 18.064C25.0859 18.2465 25.4734 18.404 25.87 18.5354C26.2254 18.6355 26.5629 18.7913 26.87 18.9969C26.9622 19.0711 27.0357 19.1661 27.0843 19.2742Z" fill="white"/>
        </g>
        <defs>
        <filter id="filter0_d_14309_4164" x="0" y="0" width="38" height="42" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="1"/>
        <feGaussianBlur stdDeviation="2.5"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.937255 0 0 0 0 0.588235 0 0 0 0 0 0 0 0 0.45 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_14309_4164"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_14309_4164" result="shape"/>
        </filter>
        </defs>
        </svg>`,
      };
    } else if (d.mode === "E") {
      let iconUrl = `data:image/svg+xml;utf-8,
        <svg width="${width}" height="${height}" viewBox="0 0 38 42" fill="none" xmlns="http://www.w3.org/2000/svg" id="event-marker">
        <g filter="url(%23filter0_d_14309_4166)">
        <path d="M5.5 17.7143C5.5 10.4259 11.5344 4.5 19 4.5C26.4656 4.5 32.5 10.4259 32.5 17.7143C32.5 23.4606 28.7508 28.3588 23.5031 30.1757C22.8482 30.4025 22.3353 30.9237 21.9187 31.4855C21.513 32.0326 21.1524 32.6838 20.8209 33.2824L20.7849 33.3475C20.4332 33.9822 20.1176 34.5436 19.7904 34.9497C19.4543 35.3668 19.2007 35.5 19 35.5C18.7997 35.5 18.5487 35.3681 18.2162 34.9528C17.8919 34.5479 17.5801 33.9882 17.2306 33.3537L17.2044 33.3061C16.8723 32.7031 16.5096 32.0444 16.0975 31.4906C15.6777 30.9265 15.1601 30.4053 14.4969 30.1757C9.24924 28.3588 5.5 23.4606 5.5 17.7143Z" fill="%23D81A26" stroke="white"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.4834 18.1562V18.3464C15.4739 18.4957 15.5025 18.6449 15.5664 18.7796V19.2656L13.2837 21.3788L13.9996 18.1034L10.7 18.209L13.3148 16.1592L10.7208 14.046L14.01 14.1834L13.3356 10.8973L15.774 13.1584L17.3304 10.2L17.7765 13.4754L20.7856 12.3026L19.25 14.7645H18.4821C18.2047 14.762 17.9327 14.8429 17.7002 14.997C17.4676 15.1511 17.2849 15.3716 17.1747 15.6309L16.6455 17.237H16.3861C16.1484 17.2423 15.9218 17.3409 15.7537 17.5122C15.5855 17.6834 15.4887 17.9141 15.4834 18.1562ZM24.7932 15.4162C24.9246 15.5146 25.0276 15.6472 25.0917 15.8L25.6831 17.8815H26.3368C26.4315 17.8866 26.521 17.9272 26.5881 17.9954C26.6551 18.0637 26.695 18.1549 26.7 18.2513V18.4415C26.6952 18.539 26.6557 18.6314 26.5889 18.7015C26.522 18.7715 26.4324 18.8143 26.3368 18.8219H26.2434L26.5236 19.1071V23.5343C26.5324 23.6974 26.4791 23.8577 26.3747 23.9817C26.2703 24.1057 26.1229 24.1839 25.9633 24.2H25.4964C25.2266 24.2 24.9464 23.8196 24.9464 23.5343V22.4777H17.6831V23.5343C17.6919 23.6974 17.6386 23.8577 17.5342 23.9817C17.4298 24.1057 17.2824 24.1839 17.1228 24.2H16.6559C16.3861 24.2 16.106 23.8196 16.106 23.5343V19.1071L16.4795 18.7268H16.3861C16.2894 18.7194 16.1985 18.677 16.13 18.6072C16.0614 18.5374 16.0198 18.4448 16.0126 18.3464V18.1562C16.02 18.0588 16.0621 17.9676 16.1308 17.8995C16.1996 17.8315 16.2904 17.7912 16.3861 17.7864H17.0294L17.6831 15.8C17.7475 15.6306 17.862 15.4857 18.0107 15.3854C18.1594 15.2851 18.3349 15.2343 18.5132 15.24H24.3446C24.5069 15.2568 24.6618 15.3177 24.7932 15.4162ZM24.3446 16.0853H18.5132L17.6831 18.5366H25.1851L24.3446 16.0853ZM17.822 20.9236C17.9227 20.966 18.0307 20.9879 18.1397 20.9879C18.2496 20.9893 18.3586 20.9685 18.4605 20.9266C18.5624 20.8848 18.6552 20.8227 18.7334 20.7441C18.8115 20.6655 18.8736 20.5718 18.916 20.4686C18.9584 20.3653 18.9802 20.2545 18.9802 20.1426C18.9802 19.9156 18.8916 19.6979 18.734 19.5374C18.5764 19.3769 18.3626 19.2868 18.1397 19.2868C18.0298 19.2868 17.921 19.309 17.8196 19.3521C17.7182 19.3952 17.6263 19.4585 17.549 19.5381C17.4718 19.6177 17.4109 19.7121 17.3698 19.8159C17.3287 19.9197 17.3082 20.0307 17.3096 20.1426C17.3096 20.2536 17.3311 20.3635 17.3728 20.4661C17.4145 20.5687 17.4756 20.6618 17.5527 20.7403C17.6298 20.8188 17.7213 20.8811 17.822 20.9236ZM24.3071 20.9236C24.4078 20.966 24.5158 20.9879 24.6248 20.9879C24.7338 20.9879 24.8417 20.966 24.9424 20.9236C25.0432 20.8811 25.1346 20.8188 25.2117 20.7403C25.2888 20.6618 25.35 20.5687 25.3917 20.4661C25.4334 20.3635 25.4549 20.2536 25.4549 20.1426C25.4562 20.0307 25.4358 19.9197 25.3947 19.8159C25.3536 19.7121 25.2926 19.6177 25.2154 19.5381C25.1382 19.4585 25.0462 19.3952 24.9448 19.3521C24.8435 19.309 24.7347 19.2868 24.6248 19.2868C24.5149 19.2868 24.4061 19.309 24.3047 19.3521C24.2033 19.3952 24.1113 19.4585 24.0341 19.5381C23.9569 19.6177 23.896 19.7121 23.8549 19.8159C23.8138 19.9197 23.7933 20.0307 23.7947 20.1426C23.7947 20.2536 23.8162 20.3635 23.8579 20.4661C23.8996 20.5687 23.9607 20.6618 24.0378 20.7403C24.1149 20.8188 24.2064 20.8811 24.3071 20.9236Z" fill="white"/>
        </g>
        <defs>
        <filter id="filter0_d_14309_4166" x="0" y="0" width="38" height="42" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="1"/>
        <feGaussianBlur stdDeviation="2.5"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.847059 0 0 0 0 0.101961 0 0 0 0 0.14902 0 0 0 0.45 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_14309_4166"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_14309_4166" result="shape"/>
        </filter>
        </defs>
        </svg>`;

      if (_.includes([1, 3, 4, 5], d.mtype)) {
        iconUrl = `data:image/svg+xml;utf-8,
        <svg width="${width}" height="${height}" viewBox="0 0 38 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(%23filter0_d_14309_4165)">
        <path d="M32.5 17.7143C32.5 23.4606 28.7508 28.3588 23.5031 30.1757C22.8482 30.4025 22.3353 30.9237 21.9187 31.4855C21.513 32.0326 21.1524 32.6838 20.8209 33.2824C20.8089 33.3042 20.7969 33.3259 20.7849 33.3475C20.4332 33.9822 20.1176 34.5436 19.7904 34.9497C19.4543 35.3668 19.2007 35.5 19 35.5C18.7997 35.5 18.5487 35.3681 18.2162 34.9528C17.8919 34.5479 17.5801 33.9882 17.2306 33.3537L17.2044 33.3061C16.8723 32.7031 16.5096 32.0444 16.0975 31.4906C15.6777 30.9265 15.1601 30.4053 14.4969 30.1757C9.24924 28.3588 5.5 23.4606 5.5 17.7143C5.5 10.4259 11.5344 4.5 19 4.5C26.4656 4.5 32.5 10.4259 32.5 17.7143Z" fill="%23D81A26" stroke="white"/>
        <path d="M19 28.5C24.9371 28.5 29.75 23.6871 29.75 17.75C29.75 11.8129 24.9371 7 19 7C13.0629 7 8.25 11.8129 8.25 17.75C8.25 23.6871 13.0629 28.5 19 28.5Z" fill="%23FFEC00"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.6283 9.37707C19.4992 9.17482 19.2609 9.08132 19.0203 9.14043L15.177 10.0849C14.9311 10.1453 14.7686 10.3373 14.7426 10.5777L14.6211 12.0171L14.1712 12.1276C14.0236 12.1639 13.935 12.3197 13.9733 12.4755L14.008 12.6166C14.0463 12.7725 14.197 12.8694 14.3446 12.8332L14.4355 12.8108L14.2681 13.0983L15.0086 16.1115C15.0601 16.3211 15.2836 16.4928 15.4868 16.4429L15.8182 16.3615C16.0213 16.3115 16.1302 16.0625 16.0786 15.8529L15.9042 15.1433L20.7151 13.961L20.8895 14.6707C20.941 14.8803 21.1582 15.0492 21.3613 14.9993L21.6874 14.9191C21.8905 14.8692 22.009 14.6135 21.9575 14.4038L21.2171 11.3907L20.9355 11.2135L21.0263 11.1912C21.1739 11.1549 21.2626 10.9991 21.2243 10.8433L21.1896 10.7022C21.1513 10.5463 21.0006 10.4494 20.853 10.4856L20.4031 10.5962L19.6283 9.37707ZM15.3125 10.6365L19.1559 9.69204L20.1131 11.2116L15.1686 12.4266L15.3125 10.6365ZM15.9067 14C15.6127 14.0723 15.3112 13.8832 15.2366 13.5798C15.1621 13.2764 15.3416 12.969 15.6356 12.8968C15.9296 12.8246 16.2311 13.0137 16.3057 13.317C16.3803 13.6204 16.2007 13.9278 15.9067 14ZM20.183 12.9491C19.889 13.0214 19.5875 12.8323 19.5129 12.5289C19.4384 12.2255 19.6179 11.9182 19.9119 11.8459C20.2059 11.7737 20.5074 11.9628 20.582 12.2662C20.6565 12.5696 20.477 12.8769 20.183 12.9491Z" fill="%2313131C"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M24.58 16.8921C23.1909 16.4248 21.7381 16.1247 20.26 16C21.6337 16.322 22.9523 16.8081 24.18 17.4452C24.75 17.7664 25.29 18.2838 25.36 18.605C25.43 18.9262 25.04 19.283 24.52 19.6042L25.47 20.6391C25.7906 20.3789 26.0668 20.0783 26.29 19.7469C26.416 19.5383 26.4942 19.3093 26.52 19.0735C26.5457 18.8376 26.5185 18.5995 26.44 18.3731C26.2626 17.9875 25.964 17.6559 25.58 17.4185C25.2675 17.2133 24.9324 17.037 24.58 16.8921ZM18.53 16.1874C19.6923 16.54 20.8141 16.9911 21.88 17.5345C22.4473 17.8054 22.942 18.1828 23.33 18.6407C23.4462 18.7834 23.5185 18.9507 23.5395 19.126C23.5606 19.3013 23.5297 19.4785 23.45 19.6399C23.274 19.931 23.0063 20.1698 22.68 20.3268C22.0954 20.557 21.6084 20.9477 21.29 21.442C21.2357 21.5342 21.2073 21.6367 21.2073 21.7409C21.2073 21.8012 21.2351 21.8919 21.2584 21.9576C21.2781 22.0128 21.3058 22.0645 21.3398 22.1123C21.3817 22.171 21.4436 22.2527 21.5 22.3074C21.5973 22.4016 21.6902 22.4565 21.7884 22.5144C21.8119 22.5283 21.8358 22.5423 21.86 22.5571C22.9835 23.1653 24.3254 23.3664 25.61 23.1192L25.8 24.4485C24.1666 24.613 22.5244 24.214 21.21 23.3333C21.0411 23.2146 20.8839 23.0833 20.74 22.9408C20.588 22.7745 20.5032 22.6775 20.38 22.3876C20.2568 22.0978 20.2448 21.9603 20.2568 21.7385C20.2689 21.5167 20.3348 21.2998 20.45 21.103C20.9089 20.4781 21.5879 20.0073 22.38 19.7648C22.88 19.5418 23.18 19.2652 22.91 18.8727C22.5945 18.4452 22.1865 18.0782 21.71 17.7932C20.7099 17.1685 19.6451 16.6308 18.53 16.1874ZM17.12 16.4639C17.5749 16.709 17.9694 17.0337 18.28 17.4185C18.4516 17.6272 18.5364 17.8827 18.52 18.1411C18.4831 18.4094 18.3329 18.6551 18.1 18.828C17.6598 19.1343 17.1571 19.3615 16.62 19.4971C16.104 19.6334 15.4317 19.8022 15.05 19.8272C14.1513 19.886 13.2575 20.0516 12.43 20.3625C12.05 20.5052 11.75 20.7372 11.73 20.8799C11.71 21.0226 11.8 21.1832 12.01 21.4509L10.78 22.2092C10.6095 21.964 10.4845 21.6959 10.41 21.4152C10.3076 21.0755 10.3466 20.7141 10.52 20.3981C10.6839 20.1508 10.9022 19.9356 11.1617 19.7655C11.4212 19.5953 11.7165 19.4737 12.03 19.4079C12.5248 19.2748 13.0346 19.1911 13.55 19.1581C14.0462 19.1313 14.5438 19.1313 15.04 19.1581C15.5461 19.138 16.0504 19.0903 16.55 19.0154C17.0221 18.9418 17.4738 18.7873 17.88 18.5604C17.9764 18.5068 18.0598 18.4366 18.1252 18.3538C18.1907 18.2711 18.2369 18.1775 18.2611 18.0785C18.2854 17.9796 18.2871 17.8773 18.2663 17.7777C18.2455 17.6781 18.2026 17.5833 18.14 17.4987C17.8807 17.0966 17.5339 16.7447 17.12 16.4639Z" fill="%2313131C"/>
        </g>
        <defs>
        <filter id="filter0_d_14309_4165" x="0" y="0" width="38" height="42" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="1"/>
        <feGaussianBlur stdDeviation="2.5"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.847059 0 0 0 0 0.101961 0 0 0 0 0.14902 0 0 0 0.45 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_14309_4165"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_14309_4165" result="shape"/>
        </filter>
        </defs>
        </svg>`;
      }

      if (d.mtype >= 6 && d.mtype <= 12) {
        iconUrl = `data:image/svg+xml;utf-8,
        <svg width="${width}" height="${height}" viewBox="0 0 38 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(%23filter0_d_14312_4187)">
        <path d="M5.5 17.7143C5.5 10.4259 11.5344 4.5 19 4.5C26.4656 4.5 32.5 10.4259 32.5 17.7143C32.5 23.4606 28.7508 28.3588 23.5031 30.1757C22.8482 30.4025 22.3353 30.9237 21.9187 31.4855C21.513 32.0326 21.1524 32.6838 20.8209 33.2824L20.7849 33.3475C20.4332 33.9822 20.1176 34.5436 19.7904 34.9497C19.4543 35.3668 19.2007 35.5 19 35.5C18.7997 35.5 18.5487 35.3681 18.2162 34.9528C17.8919 34.5479 17.5801 33.9882 17.2306 33.3537L17.2044 33.3061C16.8723 32.7031 16.5096 32.0444 16.0975 31.4906C15.6777 30.9265 15.1601 30.4053 14.4969 30.1757C9.24924 28.3588 5.5 23.4606 5.5 17.7143Z" fill="%23D81A26" stroke="white"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M23.3471 11.5H27.8238V12.3313L25.1545 16.1063H27.8471V17.3H23.3471V16.446L25.9712 12.7052H23.3471V11.5ZM19.5 15.5H22.4608V16.1559L22.2574 16.504L20.951 18.4928H22.5V19.5H19.5V18.8314L20.1056 17.8891L21.0189 16.5072H19.5V15.5Z" fill="white"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.14 16.8875C18.14 18.206 17.0744 19.2749 15.76 19.2749C14.4455 19.2749 13.38 18.206 13.38 16.8875C13.38 15.5689 14.4455 14.5 15.76 14.5C17.0744 14.5 18.14 15.5689 18.14 16.8875ZM20.5 22.6367C20.5 21.0518 17.34 20.2493 15.75 20.2493C14.16 20.2493 11 21.0518 11 22.6367V23.8305H12.77C12.77 23.0323 13.0861 22.2669 13.6487 21.7025C14.2113 21.1381 14.9743 20.8211 15.77 20.8211C16.5656 20.8211 17.3287 21.1381 17.8913 21.7025C18.4539 22.2669 18.77 23.0323 18.77 23.8305H20.54L20.5 22.6367ZM15.75 21.6737C15.1798 21.6737 14.6329 21.9009 14.2297 22.3054C13.8265 22.7098 13.6 23.2584 13.6 23.8304H17.93C17.93 23.5446 17.8734 23.2617 17.7635 22.9981C17.6536 22.7344 17.4925 22.4953 17.2897 22.2946C17.0869 22.094 16.8463 21.9357 16.582 21.8291C16.3176 21.7225 16.0349 21.6697 15.75 21.6737Z" fill="white"/>
        </g>
        <defs>
        <filter id="filter0_d_14312_4187" x="0" y="0" width="38" height="42" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="1"/>
        <feGaussianBlur stdDeviation="2.5"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.847059 0 0 0 0 0.101961 0 0 0 0 0.14902 0 0 0 0.45 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_14312_4187"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_14312_4187" result="shape"/>
        </filter>
        </defs>
        </svg>`;
      }

      if (d.mtype >= 13 && d.mtype <= 15) {
        iconUrl = `data:image/svg+xml;utf-8,
        <svg width="${width}" height="${height}" viewBox="0 0 38 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(%23filter0_d_14732_4121)">
        <path d="M32.5 17.7143C32.5 23.4606 28.7508 28.3588 23.5031 30.1757C22.8482 30.4025 22.3353 30.9237 21.9187 31.4855C21.513 32.0326 21.1524 32.6838 20.8209 33.2824C20.8089 33.3042 20.7969 33.3259 20.7849 33.3475C20.4332 33.9822 20.1176 34.5436 19.7904 34.9497C19.4543 35.3668 19.2007 35.5 19 35.5C18.7997 35.5 18.5487 35.3681 18.2162 34.9528C17.8919 34.5479 17.5801 33.9882 17.2306 33.3537L17.2044 33.3061C16.8723 32.7031 16.5096 32.0444 16.0975 31.4906C15.6777 30.9265 15.1601 30.4053 14.4969 30.1757C9.24924 28.3588 5.5 23.4606 5.5 17.7143C5.5 10.4259 11.5344 4.5 19 4.5C26.4656 4.5 32.5 10.4259 32.5 17.7143Z" fill="%23D81A26" stroke="white"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.0065 10.1747C21.4852 10.1747 23.5016 12.0149 23.5016 14.2771C23.5016 18.3795 19.0065 21.8958 19.0065 21.8958C19.0065 21.8958 14.5113 18.3795 14.5113 14.2771C14.5113 12.0149 16.5277 10.1747 19.0065 10.1747ZM21.3373 14.5034C21.3373 15.7907 20.2937 16.8342 19.0065 16.8342C17.7192 16.8342 16.6756 15.7907 16.6756 14.5034C16.6756 13.2161 17.7192 12.1726 19.0065 12.1726C20.2937 12.1726 21.3373 13.2161 21.3373 14.5034ZM21.6421 20.3556C21.3913 20.3112 21.1525 20.482 21.1089 20.7371C21.0652 20.9922 21.2332 21.235 21.484 21.2794C21.8294 21.3405 22.1498 21.4136 22.4405 21.4964C22.6856 21.5663 22.9401 21.4208 23.0088 21.1715C23.0775 20.9222 22.9345 20.6634 22.6893 20.5935C22.3654 20.5012 22.0144 20.4214 21.6421 20.3556ZM16.5289 21.2794C16.7798 21.235 16.9477 20.9922 16.9041 20.7371C16.8604 20.482 16.6217 20.3112 16.3708 20.3556C15.9985 20.4214 15.6475 20.5012 15.3236 20.5935C15.0785 20.6634 14.9354 20.9222 15.0041 21.1715C15.0729 21.4208 15.3273 21.5663 15.5725 21.4964C15.8631 21.4136 16.1835 21.3405 16.5289 21.2794ZM14.0174 22.2933C14.175 22.09 14.1407 21.7952 13.9408 21.6348C13.7408 21.4745 13.4509 21.5094 13.2933 21.7127C13.1267 21.9275 13.0129 22.1871 13.0129 22.481C13.0129 22.775 13.1267 23.0345 13.2933 23.2493C13.4509 23.4527 13.7408 23.4875 13.9408 23.3272C14.1407 23.1669 14.175 22.8721 14.0174 22.6688C13.9473 22.5784 13.935 22.5175 13.935 22.481C13.935 22.4446 13.9473 22.3837 14.0174 22.2933ZM24.7197 21.7127C24.562 21.5094 24.2721 21.4745 24.0722 21.6348C23.8722 21.7952 23.8379 22.09 23.9956 22.2933C24.0657 22.3837 24.0779 22.4446 24.0779 22.481C24.0779 22.5175 24.0657 22.5784 23.9956 22.6688C23.8379 22.8721 23.8722 23.1669 24.0722 23.3272C24.2721 23.4875 24.562 23.4527 24.7197 23.2493C24.8862 23.0345 25 22.775 25 22.481C25 22.1871 24.8862 21.9275 24.7197 21.7127ZM15.5725 23.4656C15.3273 23.3958 15.0729 23.5412 15.0041 23.7906C14.9354 24.0399 15.0785 24.2987 15.3236 24.3685C15.6475 24.4608 15.9985 24.5406 16.3708 24.6065C16.6217 24.6509 16.8604 24.4801 16.9041 24.225C16.9477 23.9699 16.7798 23.7271 16.5289 23.6827C16.1835 23.6216 15.8631 23.5485 15.5725 23.4656ZM22.6893 24.3685C22.9345 24.2987 23.0775 24.0399 23.0088 23.7906C22.9401 23.5412 22.6856 23.3958 22.4405 23.4656C22.1498 23.5485 21.8294 23.6216 21.484 23.6827C21.2332 23.7271 21.0652 23.9699 21.1089 24.225C21.1525 24.4801 21.3913 24.6509 21.6421 24.6065C22.0144 24.5406 22.3654 24.4608 22.6893 24.3685ZM18.5069 23.8798C18.2524 23.8719 18.0397 24.0752 18.0319 24.334C18.0241 24.5929 18.2241 24.8091 18.4786 24.8171C18.6525 24.8225 18.8286 24.8253 19.0065 24.8253C19.1844 24.8253 19.3605 24.8225 19.5343 24.8171C19.7888 24.8091 19.9888 24.5929 19.981 24.334C19.9732 24.0752 19.7605 23.8719 19.506 23.8798C19.3416 23.8849 19.175 23.8876 19.0065 23.8876C18.838 23.8876 18.6713 23.8849 18.5069 23.8798Z" fill="white"/>
        </g>
        <defs>
        <filter id="filter0_d_14732_4121" x="0" y="0" width="38" height="42" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="1"/>
        <feGaussianBlur stdDeviation="2.5"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.847059 0 0 0 0 0.101961 0 0 0 0 0.14902 0 0 0 0.45 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_14732_4121"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_14732_4121" result="shape"/>
        </filter>
        </defs>
        </svg>
        `;
      }
      return {
        anchor: new maps.Point(width / 2, height - 6),
        size: new maps.Size(width, height),
        scaledSize: new maps.Size(width, height),
        url: iconUrl,
      };
    } else if (d.mode === "P") {
      if (!d.pevents || d.pevents.length === 0) {
        return {
          anchor: new maps.Point(width / 2, height - 6),
          size: new maps.Size(width, height),
          scaledSize: new maps.Size(width, height),
          url: `data:image/svg+xml;utf-8,
          <svg width="${width}" height="${height}" viewBox="0 0 38 42" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(%23filter0_d_14309_4173)">
          <path d="M32 26.5C32 28.433 30.433 30 28.5 30H23.3983C23.0741 30 22.6913 30.1046 22.4204 30.4163C22.0812 30.8065 21.7882 31.3438 21.5336 31.8517C21.4361 32.0464 21.3447 32.2355 21.2569 32.4172C21.1031 32.7353 20.9602 33.0309 20.8142 33.2945C20.4564 33.9407 20.1364 34.5153 19.8038 34.9329C19.4617 35.3624 19.2039 35.5 19 35.5C18.7977 35.5 18.544 35.3654 18.2077 34.9422C17.8801 34.53 17.5655 33.9619 17.212 33.32C17.0682 33.0588 16.9281 32.7682 16.7771 32.4551C16.6852 32.2646 16.5894 32.0658 16.4862 31.8603C16.2284 31.3464 15.9301 30.8027 15.5821 30.409C15.3111 30.1025 14.9319 30 14.6106 30H9.5C7.567 30 6 28.433 6 26.5V8.5C6 6.567 7.567 5 9.5 5H28.5C30.433 5 32 6.567 32 8.5V26.5Z" fill="%230095E0" stroke="white"/>
          <path d="M18.1084 19.7684V23.5H15.5V12.501H19.8236C20.5795 12.4855 21.329 12.6441 22.0158 12.9649C22.6289 13.2488 23.1448 13.7117 23.4976 14.2947C23.8438 14.8785 24.0165 15.5515 23.9949 16.2326C24.0225 16.7278 23.9371 17.2227 23.7452 17.6787C23.5533 18.1347 23.2601 18.5394 22.8886 18.8613C21.9949 19.5461 20.8906 19.8859 19.7729 19.8199L18.1084 19.7684ZM18.1084 17.7067H19.8236C20.232 17.7336 20.635 17.6008 20.9502 17.3356C21.0801 17.199 21.182 17.0376 21.25 16.8606C21.3179 16.6836 21.3506 16.4947 21.346 16.3048C21.3703 15.8551 21.2251 15.4128 20.94 15.0678C20.7967 14.9148 20.6232 14.7943 20.4307 14.7144C20.2383 14.6344 20.0314 14.5968 19.8236 14.6039H18.1084V17.7067Z" fill="white"/>
          </g>
          <defs>
          <filter id="filter0_d_14309_4173" x="0" y="0" width="38" height="42" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="1"/>
          <feGaussianBlur stdDeviation="2.5"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.584314 0 0 0 0 0.878431 0 0 0 0.45 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_14309_4173"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_14309_4173" result="shape"/>
          </filter>
          </defs>
          </svg>
          `,
        };
      } else {
        return {
          anchor: new maps.Point(width / 2, height - 6),
          size: new maps.Size(width, height),
          scaledSize: new maps.Size(width, height),
          url: `data:image/svg+xml;utf-8,
          <svg width="${width}" height="${height}" viewBox="0 0 39 43" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(%23filter0_d_11713_3971)">
          <path d="M32 27.5C32 29.433 30.433 31 28.5 31H23.3983C23.0741 31 22.6913 31.1046 22.4204 31.4163C22.0812 31.8065 21.7882 32.3438 21.5336 32.8517C21.4361 33.0464 21.3447 33.2355 21.2569 33.4172C21.1031 33.7353 20.9602 34.0309 20.8142 34.2945C20.4564 34.9407 20.1364 35.5153 19.8038 35.9329C19.4617 36.3624 19.2039 36.5 19 36.5C18.7977 36.5 18.544 36.3654 18.2077 35.9422C17.8801 35.53 17.5655 34.9619 17.212 34.32C17.0682 34.0588 16.9281 33.7682 16.7771 33.4551C16.6852 33.2646 16.5894 33.0658 16.4862 32.8603C16.2284 32.3464 15.9301 31.8027 15.5821 31.409C15.3111 31.1025 14.9319 31 14.6106 31H9.5C7.567 31 6 29.433 6 27.5V9.5C6 7.567 7.567 6 9.5 6H28.5C30.433 6 32 7.567 32 9.5V27.5Z" fill="%230095E0" stroke="white"/>
          <path d="M18.1084 20.7684V24.5H15.5V13.501H19.8236C20.5795 13.4855 21.329 13.6441 22.0158 13.9649C22.6289 14.2488 23.1448 14.7117 23.4976 15.2947C23.8438 15.8785 24.0165 16.5515 23.9949 17.2326C24.0225 17.7278 23.9371 18.2227 23.7452 18.6787C23.5533 19.1347 23.2601 19.5394 22.8886 19.8613C21.9949 20.5461 20.8906 20.8859 19.7729 20.8199L18.1084 20.7684ZM18.1084 18.7067H19.8236C20.232 18.7336 20.635 18.6008 20.9502 18.3356C21.0801 18.199 21.182 18.0376 21.25 17.8606C21.3179 17.6836 21.3506 17.4947 21.346 17.3048C21.3703 16.8551 21.2251 16.4128 20.94 16.0678C20.7967 15.9148 20.6232 15.7943 20.4307 15.7144C20.2383 15.6344 20.0314 15.5968 19.8236 15.6039H18.1084V18.7067Z" fill="white"/>
          <circle cx="30" cy="8" r="3.5" fill="%23D81A26" stroke="white"/>
          </g>
          <defs>
          <filter id="filter0_d_11713_3971" x="0" y="0" width="39" height="43" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="1"/>
          <feGaussianBlur stdDeviation="2.5"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.584314 0 0 0 0 0.878431 0 0 0 0.45 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_11713_3971"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_11713_3971" result="shape"/>
          </filter>
          </defs>
          </svg>
          `,
        };
      }
    }
  }
};

export const getZIndexOfMarker = (
  d: ITrackData,
  type: "first" | "last" | "arrow" | "event"
) => {
  if (type === "first") {
    return 2;
  } else if (type === "last") {
    return 2;
  } else if (type === "arrow") {
    return 1;
  } else if (type === "event") {
    if (d.mode === "E") {
      return 5;
    } else if (d.mode === "M") {
      return 6;
    } else if (d.mode === "P") {
      if (!d.pevents || d.pevents.length === 0) {
        return 3;
      } else {
        return 4;
      }
    }
  }
  return 1;
};

export const getMarker = (
  d: ITrackData,
  map: any,
  maps: any,
  type: "first" | "last" | "arrow" | "event",
  tindx?: number // tindx or heading
): any => {
  if (type === "first") {
    return new maps.Marker({
      position: { lat: d.loc[1], lng: d.loc[0] },
      map: map,
      zIndex: 2,
      clickable: true,
      icon: getIcon(d, type, maps, tindx),
    });
  } else if (type === "last") {
    return new maps.Marker({
      position: { lat: d.loc[1], lng: d.loc[0] },
      zIndex: 2,
      map: map,
      icon: getIcon(d, type, maps, tindx),
    });
  } else if (type === "arrow") {
    return new maps.Marker({
      position: { lat: d.loc[1], lng: d.loc[0] },
      map: map,
      zIndex: 1,
      icon: getIcon(d, type, maps, tindx),
    });
  } else if (type === "event") {
    if (d.mode === "E") {
      return new maps.Marker({
        position: { lat: d.loc[1], lng: d.loc[0] },
        zIndex: 5,
        map: map,
        icon: getIcon(d, type, maps, tindx),
      });
    } else if (d.mode === "M") {
      return new maps.Marker({
        position: { lat: d.loc[1], lng: d.loc[0] },
        zIndex: 6,
        map: map,
        icon: getIcon(d, type, maps, tindx),
      });
    } else if (d.mode === "P") {
      if (!d.pevents || d.pevents.length === 0) {
        return new maps.Marker({
          position: { lat: d.loc[1], lng: d.loc[0] },
          zIndex: 3,
          map: map,
          icon: getIcon(d, type, maps, tindx),
        });
      } else {
        return new maps.Marker({
          position: { lat: d.loc[1], lng: d.loc[0] },
          zIndex: 4,
          map: map,
          icon: getIcon(d, type, maps, tindx),
        });
      }
    }
  }
};
